import Header from "../header/header";
import Footer from "../footer/footer";
import NavBar from "../nav/nav-bar";
import MyThingsNav from "./my-things-nav";
import { useEffect, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Service from "../webservice/http";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import "../../src/task.css";
import { storage } from "../utils/storage";

const Task = () => {
  const services = new Service();

  const [view, setView] = useState("list");

  const [forMeNav, setForMeNav] = useState("active");
  const [createdTaskNav, setCreatedTaskNav] = useState("");
  const [showClosed, setShowClosed] = useState(false);

  const [userOptions, setUserOptions] = useState();
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [priority, setPriority] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [reminder, setReminder] = useState("");
  const [assignTo, setAssignTo] = useState([]);
  const [error, setError] = useState("");

  const [createdTaskList, setCreatedTaskList] = useState(null);
  const [assignedTaskList, setAssignedTaskList] = useState(null);

  const [detailPanel, setDetailPanel] = useState(null);
  const [taskDetail, setTaskDetail] = useState(null);
  const [assignedTaskDetail, setAssignedTaskDetail] = useState(null);
  const [requireClose, setRequireClose] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [commentDetails, setCommentDetails] = useState(null);

  const onSelectName = (selectedList) => setAssignTo(selectedList);
  const onRemoveName = (selectedList) => setAssignTo(selectedList);

  const toggleTaskNav = () => {
    if (forMeNav === "active") {
      setForMeNav("");
      setCreatedTaskNav("active");
    } else {
      setForMeNav("active");
      setCreatedTaskNav("");
    }
    setDetailPanel(null);
  };

  const resetTaskForm = () => {
    setTitle("");
    setDetail("");
    setPriority("");
    setDueDate("");
    setReminder("");
    setAssignTo([]);
    setError("");
  };

  const createTask = () => {
    setError("");
    if (title === "" || detail === "" || priority === "" || dueDate === "") {
      setError("Found empty fields...");
      return;
    }
    if (assignTo.length === 0) {
      setError("Please select at least one user");
      return;
    }
    const assign_user = assignTo.map((u) => u["username"]);
    let remind = null;
    try {
      remind = reminder.toISOString();
    } catch {
      remind = null;
    }

    const taskData = {
      title,
      detail,
      due_date: dueDate.toISOString(),
      remainder: remind,
      priority,
      assign_to: assign_user,
    };

    services.post("api/task/manage_tasks/", taskData).then((res) => {
      if (res === "TypeError: Failed to fetch") {
        setError("Failed to Fetch");
      } else {
        resetTaskForm();
        fetchCreatedTask();
        fetchAssignedTask();
        NotificationManager.success("Success", "Created New Task");
        setView("list");
      }
    });
  };

  function fetchCreatedTask() {
    const url = showClosed
      ? "api/task/all_created_task/"
      : "api/task/created_tasks/";
    services.get(url).then((res) => {
      if (res !== "TypeError: Failed to fetch") setCreatedTaskList(res);
    });
  }

  function fetchAssignedTask() {
    const url = showClosed
      ? "api/task/all_task_for_me/"
      : "api/task/manage_tasks/";
    services.get(url).then((res) => {
      if (res !== "TypeError: Failed to fetch") setAssignedTaskList(res);
    });
  }

  function fetchUserList() {
    services.get("api/access_control/all_user/").then((res) => {
      if (res !== "TypeError: Failed to fetch") setUserOptions(res);
    });
  }

  function fetchComments(task_id) {
    services.get(`api/task/${task_id}/comment/`).then((res) => {
      setCommentDetails(res !== "TypeError: Failed to fetch" ? res : null);
    });
  }

  useEffect(() => {
    fetchUserList();
    fetchCreatedTask();
    fetchAssignedTask();
  }, [showClosed]);

  function viewCreatedTaskDetail(task_id) {
    setNewComment("");
    setDetailPanel("created");
    setTaskDetail(null);
    setRequireClose(false);
    services.get(`api/task/created_tasks/${task_id}/`).then((res) => {
      if (res !== "TypeError: Failed to fetch") {
        setTaskDetail(res);
        fetchComments(task_id);
        res.assign_to.forEach((user) => {
          if (user.status === "Complete") setRequireClose(true);
        });
      }
    });
  }

  function viewAssignedTaskDetail(task_id) {
    setRequireClose(false);
    setNewComment("");
    setDetailPanel("assigned");
    setAssignedTaskDetail(null);
    services.get(`api/task/created_tasks/${task_id}/`).then((res) => {
      if (res !== "TypeError: Failed to fetch") {
        setAssignedTaskDetail(res);
        fetchComments(task_id);
      }
    });
  }

  function addNewComment(task_id) {
    services
      .post(`api/task/${task_id}/comment/`, {
        parent_id: "",
        comment: newComment,
      })
      .then((res) => {
        if (res !== "TypeError: Failed to fetch") {
          setNewComment("");
          NotificationManager.success("Success", "Added your comment");
          fetchComments(task_id);
        }
      });
  }

  function markComplete(task_id) {
    services
      .post(`api/task/${task_id}/change_status/`, { status: "Complete" })
      .then((res) => {
        if (res !== "TypeError: Failed to fetch") {
          NotificationManager.success("Success", "Marked as completed");
          viewAssignedTaskDetail(task_id);
        }
      });
  }

  function markClose(task_id) {
    services.post(`api/task/${task_id}/mark_close/`).then((res) => {
      if (res !== "TypeError: Failed to fetch") {
        NotificationManager.success("Success", "Task Closed");
        setDetailPanel(null);
        fetchCreatedTask();
        fetchAssignedTask();
      }
    });
  }

  function deleteTask(task_id) {
    services.delete(`api/task/${task_id}/delete/`).then((res) => {
      if (res !== "TypeError: Failed to fetch") {
        NotificationManager.success("Success", "Task Deleted");
        setDetailPanel(null);
        fetchCreatedTask();
        fetchAssignedTask();
      }
    });
  }

  function reopenTask(task_id) {
    services.post(`api/task/${task_id}/reopen/`, {}).then((res) => {
      if (res !== "TypeError: Failed to fetch") {
        NotificationManager.success("Success", "Task Reopened");
        setDetailPanel(null);
        fetchCreatedTask();
        fetchAssignedTask();
      }
    });
  }

  const renderDetailField = (label, value) => (
    <div className="row" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
      <div
        className="col-sm-4"
        style={{ minHeight: "30px", borderStyle: "ridge", borderWidth: "1px" }}
      >
        <label>{label}</label>
      </div>
      <div
        className="col-sm-8"
        style={{
          minHeight: "30px",
          borderStyle: "ridge",
          borderWidth: "1px",
          background: "#D8D5FF",
        }}
      >
        <p>{value}</p>
      </div>
    </div>
  );

  const renderCommentSection = (task_id) => (
    <div className="row" style={{ padding: "20px" }}>
      <div className="pannel-heading clearfix">
        <div className="pannel-heading-info">
          <h3>Comment Section</h3>
        </div>
      </div>
      <div>
        <div
          className="form-col clearfix"
          style={{ paddingLeft: 0, paddingRight: 0 }}
        >
          <div className="col-md-11">
            <input
              style={{ fontSize: "15px" }}
              type="text"
              placeholder="Add New Comments.."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
            />
          </div>
          <div className="col-md-1">
            <div className="sendButton" onClick={() => addNewComment(task_id)}>
              <i
                style={{ transform: "rotate(50deg)" }}
                className="fa fa-paper-plane"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </div>
        {commentDetails &&
          commentDetails.map((comment, idx) => (
            <div
              key={idx}
              className="row"
              style={{
                paddingLeft: "30px",
                paddingRight: "120px",
                paddingTop: "10px",
                background: "#FDFAFF",
                marginTop: "5px",
                marginBottom: "5px",
                marginLeft: "25px",
                marginRight: "25px",
              }}
            >
              <div
                className="pannel-heading-icon"
                style={{ background: "white" }}
              >
                <i
                  style={{ color: "#403EA8", fontSize: "35px" }}
                  className="fa fa-user-circle-o"
                  aria-hidden="true"
                ></i>
              </div>
              <a style={{ fontSize: "18px", color: "#645F68" }}>
                {comment.comment_by_.first_name}&nbsp;
                {comment.comment_by_.last_name}
              </a>
              <br />
              <h6 style={{ color: "#9B9A9C" }}>
                {comment.date.substring(0, 10)}
              </h6>
              <div className="row">
                <a style={{ fontSize: "15px" }}>{comment.comment}</a>
              </div>
              <br />
            </div>
          ))}
      </div>
    </div>
  );

  return (
    <div className="dashboard-body" style={{ paddingBottom: "20px" }}>
      <Header />
      <NavBar />
      <NotificationContainer />

      <div className="container-fluid" style={{ background: "#EEF2F5" }}>
        <div className="my-call">
          <div
            className="side-panel-with-table clearfix flex"
            style={{ display: "flex" }}
          >
            <MyThingsNav />

            <div className="call-table bg-white" style={{ minHeight: "603px" }}>
              <div
                className="my-calls-column"
                style={{ padding: "15px 0px 0px 15px" }}
              >
                <div className="calls-top-pannel">
                  <div className="row">
                    <div className="flex justify-between items-center px-6">
                      <div className="pannel-heading clearfix flex items-center">
                        <div className="pannel-heading-icon">
                          <i className="fa fa-tasks" aria-hidden="true"></i>
                        </div>
                        <div className="pannel-heading-info">
                          <h3>{view === "list" ? "Tasks" : "New Task"}</h3>
                        </div>
                      </div>
                      <div className="mr-8">
                        {view === "list" ? (
                          <button
                            className="px-5 py-3 mb-4 rounded-lg font-semibold hover:text-white text-gray-700 bg-white run-my-report hover:border-0"
                            onClick={() => {
                              resetTaskForm();
                              setDetailPanel(null);
                              setView("form");
                            }}
                          >
                            New Task
                          </button>
                        ) : (
                          <button
                            className="px-5 py-3 mb-4 rounded-lg font-semibold hover:text-white text-gray-700 bg-white run-my-report hover:border-0"
                            onClick={() => {
                              resetTaskForm();
                              setView("list");
                            }}
                          >
                            My Tasks
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="row" style={{ margin: 0 }}>
                    <div
                      className={detailPanel ? "col-lg-5" : "col-lg-12"}
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                    >
                      {view === "list" && (
                        <>
                          <div
                            style={{
                              padding: "0 15px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              borderBottom: "1px solid #ddd",
                              marginBottom: "4px",
                            }}
                          >
                            <ul
                              className="nav nav-tabs"
                              style={{ borderBottom: "none", marginBottom: 0 }}
                            >
                              <li role="presentation" className={forMeNav}>
                                <a
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                  onClick={toggleTaskNav}
                                >
                                  Self
                                </a>
                              </li>
                              <li
                                role="presentation"
                                className={createdTaskNav}
                              >
                                <a
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                  onClick={toggleTaskNav}
                                >
                                  Assigned
                                </a>
                              </li>
                            </ul>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                paddingBottom: "8px",
                              }}
                            >
                              <label
                                style={{
                                  fontSize: "14px",
                                  color: "#555",
                                  margin: 0,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Show Closed
                              </label>
                              <div className="toggle-switch-intregrate">
                                <input
                                  type="checkbox"
                                  id="show-closed-toggle"
                                  checked={showClosed}
                                  onChange={() => setShowClosed(!showClosed)}
                                />
                                <label htmlFor="show-closed-toggle"></label>
                              </div>
                            </div>
                          </div>

                          {forMeNav === "active" && (
                            <div
                              className="call-table"
                              style={{ width: "100%" }}
                            >
                              <table className="ss">
                                <thead>
                                  <tr>
                                    <th>
                                      <p>Task</p>
                                    </th>
                                    <th>
                                      <p>Priority</p>
                                    </th>
                                    <th>
                                      <p>Assigned By</p>
                                    </th>
                                    <th>
                                      <p>Due Date</p>
                                    </th>
                                  </tr>
                                </thead>
                                {console.log(assignedTaskList)}
                                <tbody>
                                  {assignedTaskList &&
                                  assignedTaskList.data &&
                                  assignedTaskList.data.length > 0 ? (
                                    assignedTaskList.data.map((task) => (
                                      <tr
                                        key={task.id}
                                        className="tableRow"
                                        onClick={() =>
                                          viewAssignedTaskDetail(task.id)
                                        }
                                      >
                                        <td>
                                          {task.closed && (
                                            <i
                                              style={{ color: "#5AB5BF" }}
                                              className="fa fa-low-vision"
                                              aria-hidden="true"
                                            ></i>
                                          )}
                                          {task.title}
                                        </td>
                                        <td>{task.priority}</td>
                                        <td>
                                          {task._created_by_name}&nbsp;
                                          {task._created_by_last_name}
                                        </td>
                                        <td>
                                          {task.creation_date.substring(0, 10)}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="4"
                                        style={{
                                          textAlign: "center",
                                          padding: "40px",
                                          color: "#999",
                                        }}
                                      >
                                        <i
                                          className="fa fa-inbox"
                                          aria-hidden="true"
                                          style={{
                                            fontSize: "32px",
                                            display: "block",
                                            marginBottom: "10px",
                                          }}
                                        ></i>
                                        No tasks found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}

                          {createdTaskNav === "active" && (
                            <div
                              className="call-table"
                              style={{ width: "100%" }}
                            >
                              <table className="ss">
                                <thead>
                                  <tr>
                                    <th>
                                      <p>Task</p>
                                    </th>
                                    <th>
                                      <p>Due Date</p>
                                    </th>
                                    <th>
                                      <p>Assigned To</p>
                                    </th>
                                    <th>
                                      <p>Status</p>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {createdTaskList &&
                                  createdTaskList.data &&
                                  createdTaskList.data.length > 0 ? (
                                    createdTaskList.data.map((task) => (
                                      <tr
                                        key={task.id}
                                        className="tableRow"
                                        onClick={() =>
                                          viewCreatedTaskDetail(task.id)
                                        }
                                      >
                                        <td>
                                          {task.closed && (
                                            <i
                                              style={{ color: "#5AB5BF" }}
                                              className="fa fa-low-vision"
                                              aria-hidden="true"
                                            ></i>
                                          )}
                                          {task.title}
                                        </td>
                                        <td>
                                          {task.creation_date.substring(0, 10)}
                                        </td>
                                        <td colSpan="2">
                                          {task.assign_to &&
                                            task.assign_to.map((user, i) => (
                                              <tr key={i}>
                                                <td
                                                  style={{ padding: "1px 4px" }}
                                                >
                                                  {user.user.first_name}&nbsp;
                                                  {user.user.last_name}
                                                </td>
                                                <td
                                                  style={{ padding: "1px 4px" }}
                                                >
                                                  {user.status}
                                                </td>
                                              </tr>
                                            ))}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan="4"
                                        style={{
                                          textAlign: "center",
                                          padding: "40px",
                                          color: "#999",
                                        }}
                                      >
                                        <i
                                          className="fa fa-inbox"
                                          aria-hidden="true"
                                          style={{
                                            fontSize: "32px",
                                            display: "block",
                                            marginBottom: "10px",
                                          }}
                                        ></i>
                                        No tasks found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </>
                      )}

                      {view === "form" && (
                        <div style={{ padding: "20px 15px" }}>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-col clearfix">
                                <label>Title</label>
                                <br />
                                <input
                                  type="text"
                                  placeholder="Enter task title..."
                                  value={title}
                                  onChange={(e) => setTitle(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-col clearfix">
                                <label>Details</label>
                                <br />
                                <textarea
                                  style={{ height: "120px" }}
                                  rows="4"
                                  cols="50"
                                  value={detail}
                                  onChange={(e) => setDetail(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-col clearfix">
                                <label>Priority</label>
                                <br />
                                <select
                                  value={priority}
                                  onChange={(e) => setPriority(e.target.value)}
                                >
                                  <option value="">Select</option>
                                  <option>Normal</option>
                                  <option>High</option>
                                  <option>Low</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-col clearfix">
                                <label>Due Date</label>
                                <br />
                                <Datetime
                                  onChange={setDueDate}
                                  value={dueDate}
                                  dateFormat="YYYY-MM-DD"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-col clearfix">
                                <label>Reminder</label>
                                <br />
                                <Datetime
                                  onChange={setReminder}
                                  value={reminder}
                                  dateFormat="YYYY-MM-DD"
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-col clearfix">
                                <label>Assign To</label>
                                <br />
                                <Multiselect
                                  options={userOptions}
                                  displayValue="username"
                                  onSelect={onSelectName}
                                  onRemove={onRemoveName}
                                  selectedValues={assignTo}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="popup-footer">
                            <button
                              className="btn Save"
                              type="button"
                              onClick={createTask}
                            >
                              Create
                            </button>
                          </div>

                          {error && (
                            <div className="row">
                              <div className="col-md-12">
                                <p className="errorColor">{error}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {detailPanel === "created" && taskDetail && (
                      <div
                        className="col-lg-7"
                        style={{ borderLeft: "1px solid #eee" }}
                      >
                        <div style={{ padding: "10px 15px" }}>
                          <div className="pannel-heading clearfix">
                            <div className="pannel-heading-info">
                              <h3>
                                Task{" "}
                                <i
                                  className="fa fa-upload"
                                  aria-hidden="true"
                                ></i>
                              </h3>
                            </div>
                            <div className="pannel-nav clearfix">
                              <ul className="clearfix">
                                {taskDetail.closed ? (
                                  <li>
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() => reopenTask(taskDetail.id)}
                                    >
                                      ReOpen
                                    </a>
                                  </li>
                                ) : (
                                  <>
                                    {!requireClose && (
                                      <li>
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            deleteTask(taskDetail.id)
                                          }
                                        >
                                          Delete
                                        </a>
                                      </li>
                                    )}
                                    {requireClose && (
                                      <li>
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            markClose(taskDetail.id)
                                          }
                                        >
                                          Close
                                        </a>
                                      </li>
                                    )}
                                  </>
                                )}
                              </ul>
                            </div>
                          </div>

                          <div className="row" style={{ padding: "10px 0" }}>
                            <div className="col-md-6">
                              {renderDetailField("Title", taskDetail.title)}
                              {renderDetailField("Details", taskDetail.detail)}
                              {renderDetailField(
                                "Priority",
                                taskDetail.priority,
                              )}
                              {renderDetailField(
                                "Due Date",
                                taskDetail.due_date,
                              )}
                              {taskDetail.remainder &&
                                renderDetailField(
                                  "Reminder",
                                  taskDetail.remainder,
                                )}
                            </div>
                            <div className="col-md-6">
                              <div
                                className="row"
                                style={{
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                                }}
                              >
                                <div
                                  className="col-sm-6"
                                  style={{
                                    textAlign: "center",
                                    minHeight: "30px",
                                    borderStyle: "ridge",
                                    borderWidth: "1px",
                                    background: "#D8D5FF",
                                  }}
                                >
                                  <label>Assigned To</label>
                                </div>
                                <div
                                  className="col-sm-6"
                                  style={{
                                    textAlign: "center",
                                    minHeight: "30px",
                                    borderStyle: "ridge",
                                    borderWidth: "1px",
                                    background: "#D8D5FF",
                                  }}
                                >
                                  <label>Current Status</label>
                                </div>
                              </div>
                              {taskDetail.assign_to.map((user, i) => (
                                <div
                                  key={i}
                                  className="row"
                                  style={{
                                    paddingLeft: "10px",
                                    paddingRight: "10px",
                                  }}
                                >
                                  <div
                                    className="col-sm-6"
                                    style={{
                                      minHeight: "30px",
                                      borderStyle: "ridge",
                                      borderWidth: "1px",
                                    }}
                                  >
                                    <p>
                                      {user.user.first_name}&nbsp;
                                      {user.user.last_name}
                                    </p>
                                  </div>
                                  <div
                                    className="col-sm-6"
                                    style={{
                                      minHeight: "30px",
                                      borderStyle: "ridge",
                                      borderWidth: "1px",
                                    }}
                                  >
                                    <p>{user.status}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          {renderCommentSection(taskDetail.id)}
                        </div>
                      </div>
                    )}

                    {detailPanel === "assigned" && assignedTaskDetail && (
                      <div
                        className="col-lg-7"
                        style={{ borderLeft: "1px solid #eee" }}
                      >
                        <div style={{ padding: "10px 15px" }}>
                          <div className="pannel-heading clearfix">
                            <div className="pannel-heading-info">
                              <h3>
                                Task{" "}
                                <i
                                  className="fa fa-download"
                                  aria-hidden="true"
                                ></i>
                              </h3>
                            </div>
                            <div className="pannel-nav clearfix">
                              <ul className="clearfix">
                                {assignedTaskDetail.assign_to.map((user) =>
                                  storage.getItem("username") ===
                                    user.user.username &&
                                  user.status === "Assigned" ? (
                                    <li key={user.user.username}>
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          markComplete(assignedTaskDetail.id)
                                        }
                                      >
                                        Mark Complete
                                      </a>
                                    </li>
                                  ) : null,
                                )}
                              </ul>
                            </div>
                          </div>

                          <div className="row" style={{ padding: "10px 0" }}>
                            <div className="col-md-6">
                              {renderDetailField(
                                "Title",
                                assignedTaskDetail.title,
                              )}
                              {renderDetailField(
                                "Details",
                                assignedTaskDetail.detail,
                              )}
                              {renderDetailField(
                                "Priority",
                                assignedTaskDetail.priority,
                              )}
                              {renderDetailField(
                                "Due Date",
                                assignedTaskDetail.due_date,
                              )}
                              {assignedTaskDetail.remainder &&
                                renderDetailField(
                                  "Reminder",
                                  assignedTaskDetail.remainder,
                                )}
                            </div>
                            <div className="col-md-6">
                              {assignedTaskDetail.assign_to.map((user) =>
                                storage.getItem("username") ===
                                user.user.username ? (
                                  <div
                                    key={user.user.username}
                                    className="row"
                                    style={{
                                      paddingLeft: "10px",
                                      paddingRight: "10px",
                                    }}
                                  >
                                    <div
                                      className="col-sm-6"
                                      style={{
                                        minHeight: "30px",
                                        borderStyle: "ridge",
                                        borderWidth: "1px",
                                      }}
                                    >
                                      <p>Current Status</p>
                                    </div>
                                    <div
                                      className="col-sm-6"
                                      style={{
                                        minHeight: "30px",
                                        borderStyle: "ridge",
                                        borderWidth: "1px",
                                      }}
                                    >
                                      <p>
                                        <b>{user.status}</b>
                                      </p>
                                    </div>
                                  </div>
                                ) : null,
                              )}
                            </div>
                          </div>

                          {renderCommentSection(assignedTaskDetail.id)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Task;
